import DataLayerService from "../../DataLayerService.js";
import { getMandantId, getBaseMandantId, getBaseMandantName } from "../basedata/mandant.js";
import getDeviceSize from "../basedata/device-size.js";
import getViewportWidth from "../basedata/viewport-width.js";
import { getStage } from "../basedata/stage.js";
import { getReferrer } from "../basedata/referrer.js";
import { getColorScheme } from "../basedata/color-scheme.js";
import { getKundennummer } from "../basedata/kundennummer.js";

/**
 * Basedata für DataLayer
 *
 * Pusht Basedata sofort als einzelne Werte in den DataLayer (via pushData).
 * Diese Werte sind dann als DataLayer-Variablen für GTM verfügbar.
 *
 * Zusätzlich werden die gleichen Daten vom PageviewHandler
 * beim window.load ins page_view Event integriert.
 */

const dataLayerService = new DataLayerService();

// Push Basedata sofort - nicht warten auf DOMContentLoaded oder window.load
const basedata = getBasedata();
dataLayerService.pushData(basedata);

function getBasedata() {
	const mandantid = getMandantId();
	const basedata = {
		"base-mandant": getBaseMandantId(mandantid),
		"base-name": getBaseMandantName(mandantid),
		"mandant-id": mandantid,
		"mandant-name": getBaseMandantName(mandantid),
		"device-size": getDeviceSize(),
		"viewport-width": getViewportWidth(),
		"stage": getStage(document.location.hostname || ""),
		"seite": window.location.pathname,
		"color_scheme": getColorScheme(),
		"kundennummer": getKundennummer()
	}
	const referrer = getReferrer();
	if (referrer) {
		basedata["referrer"] = referrer;
	}
	return basedata;
}
